import { getMyRouteCapabilities, MyRouteCapabilities } from "./MyRoute.policy";
import { MyRouteData } from "./MyRoute.types";

export interface MyRouteModel {
    capabilities: MyRouteCapabilities;
    route: {
        title: string;
        description: string;
    };
    data: MyRouteData;
}

interface BuildMyRouteModelInput extends MyRouteData {
    role: Parameters<typeof getMyRouteCapabilities>[0];
    routeName?: string | null;
}

export const buildMyRouteModel = ({
    role,
    routeName,
    routeDetails,
    points,
    schedules,
}: BuildMyRouteModelInput): MyRouteModel => ({
    capabilities: getMyRouteCapabilities(role),
    route: {
        title: routeName ?? routeDetails.name ?? "",
        description: routeDetails.description ?? "",
    },
    data: {
        routeDetails,
        points,
        schedules,
    },
});
